<template>
  <div class="bg-[#D9D9D9] flex flex-col items-center">
    <h1 class="text-3xl font-medium tracking-tight text-black sm:text-4xl mb-4 mt-4">
      Partnerzy
    </h1>
    <div class="sm:w-[50%] w-[80%] h-[1px] bg-black mx-auto" />
    <div class="overflow-hidden relative py-4 sm:w-[50%] w-[80%] mx-auto">
      <div class="flex w-max animate-scroll items-center">
        <div
            v-for="(company, index) in infiniteCompanies"
            :key="index"
            class="flex items-center justify-center mx-4"
            :class="company.sizeClass"
        >
          <img :src="company.logo" :alt="company.name"
               class="object-contain"
               :class="company.sizeClass" />
        </div>
      </div>
    </div>
    <div class="sm:w-[50%] w-[80%] h-[1px] bg-black mx-auto mb-16" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      companies: [
        {name: "Bosh", logo: '/images/tools/Bosch.png', sizeClass: 'w-36 h-36'},
        {name: "Brilux", logo: "/images/tools/Brilux.png", sizeClass: 'w-36 h-36'},
        {name: "DeWalt", logo: "/images/tools/DeWalt.png", sizeClass: 'w-36 h-36'},
        {name: "Festool", logo: "/images/tools/Festool.png", sizeClass: 'w-36 h-36'},
        {name: "flugger", logo: "/images/tools/flugger.png", sizeClass: 'w-36 h-36'},
        {name: "Milwake", logo: "/images/tools/Millwake.png", sizeClass: 'w-36 h-36'},
        {name: "Sika", logo: "/images/tools/Sika.png", sizeClass: 'w-36 h-36'},
        {name: "Sopro", logo: "/images/tools/Sopro.png", sizeClass: 'w-36 h-36'},
        {name: "Wurth", logo: "/images/tools/wurth.png", sizeClass: 'w-36 h-36'},
      ],
    };
  },
  computed: {
    infiniteCompanies() {
      return [...this.companies, ...this.companies, ...this.companies];
    },
  },
};
</script>

<style scoped>
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-33.33%);
  }
}

.animate-scroll {
  display: flex;
  white-space: nowrap;
  animation: scroll 16s linear infinite;
}
</style>
